angular.module('dnecom')
    .controller('CollectionItemModalController', CollectionItemModalController);

CollectionItemModalController.$inject = ['$scope', '$uibModalInstance', 'collectionItem', 'isInEditMode', 'storeId'];

function CollectionItemModalController($scope, $uibModalInstance, collectionItem, isInEditMode, storeId) {
    $scope.item = collectionItem;
    $scope.isInEditMode = isInEditMode;
    $scope.storeId = storeId;

    $scope.save = function (form) {
        if (form.$invalid || form.$pending) {
            form.$setTouched();

            return false;
        }

        $uibModalInstance.close($scope.item);
    };

    $scope.setSlug  = function () {
        if ($scope.item.title) {
            var origin = $scope.item.title;
            origin = origin.replace(/^\s+|\s+$/g, ''); // trim
            origin = origin.toLowerCase();

            // remove accents, swap ñ for n, etc
            var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
            var to   = "aaaaeeeeiiiioooouuuunc------";
            for (var i=0, l=from.length ; i<l ; i++) {
                origin = origin.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            origin = origin.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by -
                .replace(/-+/g, '-'); // collapse dashes

            $scope.item.slug = origin;
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
};


